import { changesDiscarded } from './showUndoNotificationForCompose.locstring.json';
import { undo_0 } from 'owa-locstrings/lib/strings/undo_0.locstring.json';
import loc from 'owa-localize';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import handleUndoNotificationCallback from 'owa-calendar-compose-form-orchestration/lib/utils/handleUndoNotificationCallback';
import { QuickComposeViewState } from 'owa-calendar-compose-types';
import { ControlIcons } from 'owa-control-icons';
import { DefaultHotKeyCommand, lazyShowCalendarNotification } from 'owa-calendar-notification-bar';
import { orchestrator } from 'satcheljs';
import {
    showUndoNotificationForCompose,
    updateIsUndoNotificationShown,
} from 'owa-calendar-compose-form-actions';

export const UNDO_NOTIFICATION_ID = 'composeUndoNotification';

export default orchestrator(showUndoNotificationForCompose, actionMessage => {
    const store = getComposeStore();
    const entrySource = store.metricsInfo.quickComposeEntrySource;
    const notificationText = loc(changesDiscarded);

    updateIsUndoNotificationShown(true);
    lazyShowCalendarNotification.import().then(showCalendarNotification => {
        showCalendarNotification(
            UNDO_NOTIFICATION_ID,
            'EditForm',
            notificationText,
            {
                icon: ControlIcons.Delete,
                primaryActionHotKeyCommand: DefaultHotKeyCommand.Undo,
            },
            {
                primaryActionText: loc(undo_0),
                notificationCallback: reason =>
                    handleUndoNotificationCallback(
                        reason,
                        actionMessage.composeFormType,
                        entrySource,
                        (store?.uiState as QuickComposeViewState)?.surfaceAnchor
                    ),
            }
        );
    });
});
